import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Request a password-reset email (MEA-160). Public route: /reset-password.
export default function ResetPassword() {
  const { resetPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    const { error } = await resetPassword(email);
    setSubmitting(false);
    if (error) setError(error.message);
    else setSent(true);
  };

  return (
    <div className="min-h-screen bg-canvas text-ink flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/dinner-league-icon-192.png" alt="" aria-hidden="true" className="w-14 h-14 mx-auto mb-4 rounded-btn shadow-glow-sm" />
          <h1 className="font-display text-2xl font-semibold text-ink mb-2">Reset your password</h1>
          <p className="font-body text-sm text-ink-soft">
            Enter your email and we'll send you a link to set a new password.
          </p>
        </div>

        {sent ? (
          <div className="rounded-panel border border-hairline p-6 text-center" style={{ background: '#0d1220' }}>
            <div className="text-4xl mb-3">📬</div>
            <h3 className="font-display font-bold text-ink mb-2">Check your email</h3>
            <p className="font-body text-sm text-ink-soft">
              If an account exists for <span className="font-semibold text-ink">{email}</span>, a reset link is on its way.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="rounded-panel border border-hairline p-6" style={{ background: '#0d1220' }}>
            <label htmlFor="email" className="block font-display text-xs font-bold text-ink-soft mb-1.5">
              Email address
            </label>
            <input
              id="email"
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className="w-full px-4 py-3 rounded-btn border border-hairline font-body text-ink placeholder:text-ink-faint focus:outline-none focus:ring-2 focus:ring-lime/60 focus:border-transparent transition"
              style={{ background: '#0a1220' }}
            />
            {error && <p className="mt-3 font-body text-sm text-red-400">{error}</p>}
            <button
              type="submit"
              disabled={submitting}
              className="w-full mt-5 py-3 rounded-btn bg-lime-gradient text-canvas font-display font-bold shadow-glow hover:brightness-110 transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {submitting ? 'Sending…' : 'Send reset link'}
            </button>
          </form>
        )}

        <div className="text-center mt-6">
          <Link to="/" className="font-body text-sm text-lime hover:brightness-110 transition">
            ← Back to sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
